import { login, loginProps, loginWithPin } from '@/api/server/user/read';

export const pinLogin = async (aPayload: loginProps) => {
  const payload = {
    email: String(aPayload.email),
    pin_pw: aPayload.pin_pw,
  };
  const type = 'pin' as const;
  const res = await loginCheck({ payload, type });
  return res;
};
// 타입별 로그인 시도
type loginCheckProps = {
  payload: loginProps;
  type: 'email' | 'pin';
};
export const loginCheck = async (aData: loginCheckProps) => {
  let re = null;
  if (aData.type === 'email') {
    re = await login(aData.payload);
  } else if (aData.type === 'pin') {
    re = await loginWithPin(aData.payload);
  }

  if (re.ret_code !== 200) {
    return { code: re.ret_code, msg: re.msg };
  }
  const payload = {
    key: 'auth',
    value: {
      auth: re.data.auth_token,
      point: re.data.point_token,
      // data
    },
  };
  return { code: re.ret_code, msg: re.msg, data: payload };
};
